// extracted by mini-css-extract-plugin
module.exports = {"withBullet":"style-module--withBullet--2NUZ6"};